import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControlLabel,
  Grid,
  Modal,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SnackBarUI from "../../comman/SnackBarUI";
// import SnackBarUI from "./SnackBarUI"; // assuming you have this
// import { partnerSchema } from "./validationSchema"; // adjust import
import * as yup from "yup";
import { updatePUblisherStoreAction } from "../../redux/toolkit/publisher/updatePublisherStore";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import { getPUblisherTokenAction } from "../../redux/toolkit/publisher/getPublisherToken";
import { AirlineSeatIndividualSuiteSharp } from "@mui/icons-material";
import Icon from "@mui/icons-material";

const partnerSchema = yup
  .object({
    // name: yup.string().required("Partner Name is required"),
  })
  .required();

const PubisherVoucherStore = ({ state, setState, appId, storeData }) => {
  const dispatch = useDispatch();
  const [snack, setSnack] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(partnerSchema),
    defaultValues: {
      is_active: false,
      topupx_token: "",
      topupx_secret: "",
      topupx_app_key: "",
    },
  });

  const tokenInfo = useSelector((state) => state.publisherTokenInfo);
  const { loading, data } = tokenInfo;


  const handleUpdateStore = async (formValues) => {
    console.log("Submitting form:", formValues);
    // dispatch API call here with publisherId + formValues
    let updateStore = await dispatch(
      updatePUblisherStoreAction({
        ...formValues,
        appId: appId,
      })
    );

    setSnack(true);
    setState(false);
    window.location.reload();
  };

  const handleGetToken = async () => {
    let getToken = await dispatch(getPUblisherTokenAction({}));
  };

  const handleClose = () => {
    setState(false);
  };

  useEffect(() => {
    if (data?.token) {
      // assuming your API returns { token: "xyz" }
      setValue("topupx_token", data.token, { shouldValidate: true });
    }
  }, [data, setValue]);

  useEffect(() => {
    if (storeData) {
      reset({
        is_active: storeData?.is_active,
        topupx_token: storeData?.topupx_token,
        topupx_secret: storeData?.topupx_secret,
        topupx_app_key: storeData?.topupx_app_key,
      });
    }
  }, [storeData, reset]);

  return (
    <>
      <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
        <Box
          className="modal_box"
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <Card sx={{ width: 500, p: 5 }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Store Data
            </Typography>

            <form onSubmit={handleSubmit(handleUpdateStore)}>
              <Grid item xs={12} sm={6}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="topupx_token"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="topupx_token"
                        placeholder="topupx_token"
                        error={!!errors?.topupx_token}
                        helperText={errors?.topupx_token?.message}
                      />
                    )}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={handleGetToken}
                  >
                    Get Token
                  </Button>
                </Grid>

                <Controller
                  name="is_active"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          {...field}
                          checked={field.value || false}
                          onChange={(e) => field.onChange(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Is Active"
                    />
                  )}
                />
                {errors?.is_active && (
                  <p style={{ color: "red", fontSize: "0.8rem" }}>
                    {errors.is_active.message}
                  </p>
                )}
              </Grid>
              <Grid container spacing={2}>
                {/* Switch */}

                {/* topupx_token */}
                {/* <Grid item xs={12} sm={6}>
                  <Controller
                    name="topupx_token"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="topupx_token"
                        placeholder="topupx_token"
                        error={!!errors?.topupx_token}
                        helperText={errors?.topupx_token?.message}
                      />
                    )}
                  />
                </Grid> */}

                {/* topupx_secret */}
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="topupx_secret"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="topupx_secret"
                        placeholder="topupx_secret"
                        error={!!errors?.topupx_secret}
                        helperText={errors?.topupx_secret?.message}
                      />
                    )}
                  />
                </Grid>

                {/* topupx_app_key */}
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="topupx_app_key"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="topupx_app_key"
                        placeholder="topupx_app_key"
                        error={!!errors?.topupx_app_key}
                        helperText={errors?.topupx_app_key?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Stack direction="row" spacing={2} mt={3}>
                <Button
                  sx={{ zIndex: 1000 }}
                  variant="contained"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} /> : "Save"}
                </Button>

                <Button variant="contained" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>

      {snack && (
        <SnackBarUI
          state={snack}
          setState={setSnack}
          // status={amount_status}
          // message={amount_message}
        />
      )}
    </>
  );
};

export default PubisherVoucherStore;
